export enum TagColors {
    Blue = 'Blue',
    Green = 'Green'
}
